import { FlexContainer } from "../Container/FlexContainer";

export class FileContainer extends FlexContainer {
    public getFileData() {
        return this.get("fdata");
    }

    public getFile() {
        return this.get("f");
    }

    protected initialize(data: any) {
        super.initialize(data);
        const file = this.getFile();
        const reader = new FileReader();

        reader.onload = (event: ProgressEvent | any) => {
            this.addToData("fdata",
                {
                    date: file.lastModified,
                    fileData: event.target.result,
                    name: file.name,
                    size: file.size,
                    type: file.type,
                });
        };

        reader.readAsDataURL(file);
    }
}
